import React, { useEffect } from 'react';
import * as styles from './hubspotForm.module.scss';

interface Props {
  portalId: string;
  formId: string;
  region?: string;
}

export const HubspotForm: React.FC<Props> = ({ portalId, formId, region = 'eu1' }) => {
  useEffect(() => {
    // Load HubSpot script
    const script = document.createElement('script');
    script.src = `https://js-${region}.hsforms.net/forms/embed/${portalId}.js`;
    script.defer = true;
    script.onload = () => {
      // The script is loaded and window.hbspt is available
      console.log('HubSpot script loaded');
    };
    document.body.appendChild(script);

    return () => {
      // Cleanup script when component unmounts
      document.body.removeChild(script);
    };
  }, [portalId, region]);

  return (
    <div className={styles.hubspotFormWrapper}>
      <div 
        className="hs-form-frame"
        data-region={region}
        data-form-id={formId}
        data-portal-id={portalId}
      />
    </div>
  );
}; 